export default __webpack_public_path__ + "static/media/yucebey11.1afb0e7f.jpg";